<template>
  <div class="content">

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan'}" :to="{ name: 'pembukuan' }" v-on:click.native="data.tabActive = 'pembukuan'">
            Periode Pembukuan
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan-pemasukkan'}" :to="{ name: 'pembukuan-pemasukkan' }" v-on:click.native="data.tabActive = 'pembukuan-pemasukkan'">
            Pemasukkan
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan-pengeluaran'}" :to="{ name: 'pembukuan-pengeluaran' }" v-on:click.native="data.tabActive = 'pembukuan-pengeluaran'">
            Pengeluaran
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan-sisa'}" :to="{ name: 'pembukuan-sisa' }" v-on:click.native="data.tabActive = 'pembukuan-sisa'">
            Uang di Kang Tagih
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan-viaonline'}" :to="{ name: 'pembukuan-viaonline' }" v-on:click.native="data.tabActive = 'pembukuan-viaonline'">
            Bayar Via Online
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'pembukuan-viacast'}" :to="{ name: 'pembukuan-viacast' }" v-on:click.native="data.tabActive = 'pembukuan-viacast'">
            Bayar Via Cash
          </router-link>
        </li>
      </ul>
    </nav>

    <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>

  </div>
</template>

<script>
import Vue from 'vue'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
    name: 'Beranda',
    components: { 
      "Loading" : Loading
    }, 
    setup() {
      const data = reactive({
        tabActive: "pembukuan"
      })

      return {
        data
      }

    },
    mounted () {

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/main.vue